// extracted by mini-css-extract-plugin
export default {"root":"ImageEditor__root__IEqrN","resizeWrapper":"ImageEditor__resizeWrapper__YHDBH"};